import React, { useEffect, useState } from 'react';
import Layout, { NAVBAR_ISMINIMIZED_KEY } from '../../components/Layout/Layout.component';
import { useStyles } from '../styles';
// import { useStyles as mainStyles } from '../styles';
import Breadcrumbs from '../../components/Breadcrumbs.component';
import { ButtonOne } from '../../components/ButtonOne/ButtonOne.component';
import { AxiosResponse } from 'axios';
import {
  getInstructionsList,
  deleteInstruction,
  likeInstruction,
  dislikeInstruction,
} from '../../services/support/instructions/supportInstructions.service';
import {
  IInstructionListResponse,
  IInstructionListItem,
} from '../../services/support/instructions/supportInstructions.types';
import { NavLink } from 'react-router-dom';

import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import { InstructionCard } from '../../components/Support/Instructions/InstructionCard/InstructionCard.component';
import usePermission, { UserPermission } from '../../hooks/usePermission';
import { Prompt } from '../../components/Prompt/Prompt.component';
import { useLayoutContext } from '../../Context/Layout.context';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { useTranslation } from 'react-i18next';
import { Paths } from '../../utils/routerUrls';

const SupportInstructions: React.FC = () => {
  const [instructions, setInstructions] = useState<IInstructionListItem[]>([]);

  const { showLoader } = useLayoutContext();

  const [deletingInstructionPromptData, setDeletingInstructionPromptData] = useState<
    { instructionId: string; title: string } | undefined
  >(undefined);

  const classes = useStyles();
  // const mainClasses = mainStyles();

  const isAdminPermission = usePermission(UserPermission.AdminSupportManage);
  const { openAlert } = useLayoutContext();
  const { t } = useTranslation();
  useDocumentTitle('Instrukcje interaktywne');

  const refreshData = () => {
    showLoader(true);
    getInstructionsList()
      .then((response: AxiosResponse<IInstructionListResponse>) => {
        setInstructions(response.data.list);
      })
      .catch(() => {
        console.error('error');
      })
      .finally(() => showLoader(false));
  };

  useEffect(() => {
    refreshData();
  }, []);

  const handleDeleteInstruction = (instructionId: string) => {
    deleteInstruction(instructionId)
      .then((response: AxiosResponse<boolean>) => {
        if (response.data) {
          openAlert('success', 'Usunięcie pytania zakończone sukcesem');
          refreshData();
        } else {
          openAlert('error', `Usunięcie pytania nie powiodło się`);
        }
      })
      .finally(() => {
        setDeletingInstructionPromptData(undefined);
      });
  };

  const updateInstructionsLike = (instructionId: string, isLiked: boolean) => {
    const newList = instructions.map((instruction) => {
      if (instruction.id === instructionId) {
        const updatedInstruction = {
          ...instruction,
          isLiked: isLiked,
        };

        return updatedInstruction;
      }

      return instruction;
    });

    setInstructions(newList);
  };

  const like = async (instructionId: string) => {
    const response = await likeInstruction(instructionId);
    if (response.data) {
      updateInstructionsLike(instructionId, true);
    }
  };

  const dislike = async (instructionId: string) => {
    const response = await dislikeInstruction(instructionId);
    if (response.data) {
      updateInstructionsLike(instructionId, false);
    }
  };

  return (
    <>
      <Layout viewType={isAdminPermission ? 'admin' : 'fullwidthForExaminer'}>
        <div className={classes.tableAndBreadcrumContainer}>
          <div className={classes.breadcrumbHeader}>
            <Breadcrumbs
              listRoute={Paths.supportInstructions}
              currentList={'Instrukcje interaktywne'}
              mainElementRoute={Paths.support}
              mainElement={`Centrum pomocy ${t('global:shortNames.beneficiary')} ${t('global:shortNames.system')}`}
            />
            {isAdminPermission && (
              <div className={classes.buttonsContainer}>
                <NavLink to={`${Paths.supportInstructions}/0/add`}>
                  <ButtonOne className={classes.primary} variant="contained" aria-label="Dodaj instrukcję">
                    <span style={{ margin: '0px 10px 0px -4px', fontSize: '20px' }}>+</span>{' '}
                    {t('support:header.addInstruction')}
                  </ButtonOne>
                </NavLink>
              </div>
            )}
          </div>
          <Typography variant="h1" className={classes.gridHeader} style={{ margin: '0px 30px 15px 15px'}}>
            Instrukcje interaktywne
          </Typography>

          <Grid container style={{ width: 'calc(100% - 15px)', overflow: 'auto', maxHeight: 'calc(100% - 130px)' }}>
            {instructions.map((instruction) => (
              <React.Fragment key={instruction.id}>
                <InstructionCard
                  instructionProp={instruction}
                  deleteFunc={() =>
                    setDeletingInstructionPromptData({ instructionId: instruction.id, title: instruction.title })
                  }
                  likeFunc={() => like(instruction.id)}
                  dislikeFunc={() => dislike(instruction.id)}
                  isEdit={isAdminPermission}
                />
              </React.Fragment>
            ))}
          </Grid>

          {deletingInstructionPromptData && (
            <Prompt
              type="confirmation"
              open={true}
              size="xs"
              onConfirm={() => handleDeleteInstruction(deletingInstructionPromptData.instructionId)}
              onCancel={() => setDeletingInstructionPromptData(undefined)}
              mainActionButtonText="TAK"
              mainText="Czy na pewno chcesz usunąć instrukcje:"
              subTexts={[{ text: deletingInstructionPromptData.title }]}
            />
          )}
        </div>
      </Layout>
    </>
  );
};

export default SupportInstructions;
